import '../lib/typedef';
import { buildQuery } from '../lib/helper';
import client from '../lib/http-client';

const endpoint = '/product';

export default {
	getProducts(params, cb, errorCb) {
		// const url = `/product/?limit=${params.limit}&sort_by=${params.sort_by}&sort=${params.sort}&page=${params.page}`;
		const query = buildQuery(params);
		const url = `/product?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getProductsV2(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `/product/list_v2?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getPublicProducts(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/public?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getPublicProductOptions(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/public/options?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getProductsList(cb, errorCb) {
		const url = '/product/list';
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getDropshipProducts(params, cb, errorCb) {
		// const url = `/product/?limit=${params.limit}&sort_by=${params.sort_by}&sort=${params.sort}&page=${params.page}`;
		const query = buildQuery(params);
		const url = `/product/dropship?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getAddedDropshipProducts(cb, errorCb) {
		// const url = `/product/?limit=${params.limit}&sort_by=${params.sort_by}&sort=${params.sort}&page=${params.page}`;
		// const query = buildQuery(params);
		const url = '/product/dropship/added';
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	async addDropshipProduct(id, params) {
		// const url = `/product/?limit=${params.limit}&sort_by=${params.sort_by}&sort=${params.sort}&page=${params.page}`;
		// const query = buildQuery(params);
		const url = `/product/${id}/dropship`;
		try {
			const response = await client.post(url, params);
			return response.data;
			// cb(response.data);
		} catch (error) {
			return error;
		}
	},


	getProductsListWithParams(params, cb, errorCb) {
		const url = '/product/list';
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getProductsListURL(cb, errorCb) {
		const url = `${endpoint}/list?get_product_url=true`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getMinimalProducts(params, cb, errorCb) {
		const url = `${endpoint}/list`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getProductDetails(id, cb, errorCb, params = {}) {
		let url = `/product/${id}`;

		if (params.show_variation_table) {
			url += `?show_variation_table=${params.show_variation_table}`;
		}

		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	createProduct(params, cb, errorCb) {
		const url = '/product';
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/**
	 * Bulk Update Product Properties
	 *
	 * @param {} params
	 * @param {*} cb
	 * @param {*} errorCb
	 */
	bulkUpdate(params, cb, errorCb) {
		const url = endpoint;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getAutoText(id, cb, errorCb) {
		const url = `/product/${id}/follow_up_autotext`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	validateSlug(id, slug, cb, errorCb) {
		const url = '/product/slug';
		const params = {
			product_id: id,
			slug,
		};
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	bulkDelete(ids = [], cb, errorCb) {
		const url = '/product';

		const idsJSON = JSON.stringify(ids);
		const params = {
			product_ids: idsJSON,
		};

		client.delete(url, { data: params })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	bulkArchive(ids = [], cb, errorCb) {
		const url = '/product/archive';

		const idsJSON = JSON.stringify(ids);
		const productIds = idsJSON;

		client.put(url, { product_ids: productIds })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	updateAutoText(id, autotext, gateways, cb, errorCb) {
		const url = `${endpoint}/${id}/follow_up_autotext`;

		const params = {
			follow_up_autotext: JSON.stringify(autotext),
			wa_gateways: JSON.stringify(gateways),
		};

		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	updateAutoTextSms(id, autotext, cb, errorCb) {
		const url = `${endpoint}/${id}/sms_autotext`;

		const params = {
			sms_autotext: JSON.stringify(autotext),
		};

		client.put(url, params)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	updateNotifications(id, notifications, cb, errorCb) {
		const url = `${endpoint}/${id}/notifications`;

		const params = {
			notifications: JSON.stringify(notifications),
		};

		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	updateContactFormat(id, contactFormat, cb, errorCb) {
		const url = `${endpoint}/${id}/contact_format`;

		const params = {
			contact_format: JSON.stringify(contactFormat),
		};

		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	updateAutoresponders(id, autoresponders, cb, errorCb) {
		const url = `${endpoint}/${id}/autoresponders`;

		const params = {
			autoresponders: JSON.stringify(autoresponders),
		};

		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	updateCustomAudiences(id, customAudiences, cb, errorCb) {
		const url = `${endpoint}/${id}/facebook_custom_audiences`;

		const params = {
			facebook_custom_audiences: JSON.stringify(customAudiences),
		};

		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	updateTraffic(id, trafficDistributions, cb, errorCb) {
		const url = `${endpoint}/${id}/traffic_distribution`;

		const params = {
			traffic_distribution: JSON.stringify(trafficDistributions),
		};

		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	duplicate(id, cb, errorCb) {
		const url = `${endpoint}/${id}/duplicate`;
		client.post(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	updateSmsGateways(id, selectedSmsGateway, cb, errorCb) {
		const url = `${endpoint}/${id}/sms_gateways`;

		const params = {
			sms_gateways: JSON.stringify(selectedSmsGateway),
		};

		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	getBelongsTo(id, cb, errorCb) {
		const url = `${endpoint}/${id}/belongs_to`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	updateBelongsTo(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/belongs_to`;

		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	updateBelongsToBulk(params, cb, errorCb) {
		const url = `${endpoint}/bulk_belongs_to`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get List of Product Categories
	 *
	 * @param {string} parentId Parent category ID
	 * @param {requestCallback} cb Callback
	 * @param {errorCallback} errorCb Error Callback
	 */
	getCategories(parentId, cb, errorCb) {
		let url = `${endpoint}/category`;
		if (parentId) {
			url += `?parent_id=${parentId}`;
		}
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Update product stock quantity
	 *
	 * @param {string} id Product ID.
	 * @param {Object} params Stock Update Params.
	 * @param {'increase' | 'decrease' | 'sync'} params.type increase,decrease,sync.
	 * @param {number} params.quantity Stock Change Value.
	 * @param {string} params.description Description.
	 * @param {string} [params.variation] Variation name (Paket 1||Shinchan).
	 * @param {requestCallback} [cb] The callback that handles the response.
	 * @param {errorCallback} [errorCb] The callback that handles the error.
	 */
	updateStock(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/stock`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Get List of Product Activities
	 *
	 * @param {string} id Product ID
	 * @param {Object} params Product Activity Params.
	 * @param {'stock'} params.type increase,decrease,sync.
	 * @param {number} params.limit Limit.
	 * @param {number} params.page List Page.
	 * @param {string} params.sort_by Sort By.
	 * @param {'desc' | 'asc'} params.sort Sort.
	 * @param {string} [params.variation] Variation name (Paket 1||Shinchan).
	 * @param {string} [params.keyword] Search Keyword.
	 * @param {requestCallback} cb Callback
	 * @param {errorCallback} errorCb Error Callback
	*/
	getActivities(id, params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/${id}/activity?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getActivityProductStockRTS(id, params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/${id}/activity/total-stock-rts?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Export Inventory/Product
	 *
	 * @param {Object} params
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.since Date Since
	 * @param {string} params.until Date Until
	 * @param {string} [params.keyword] Search Keyword
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	export(id, params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/${id}/activity/export?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Get Unique Code
	 * @param {string} username Username
	 * @param {string} productSlug Product Slug
	 * @param {Object} params Request Parameters
	 * @param {Number} params.unique_code_min Min
	 * @param {Number} params.unique_code_max Max
	 * @param {requestCallback} cb Callback
	 * @param {errorCallback} errorCb Error Callback
	 */
	getUniqueCode(username, productSlug, params, cb, errorCb) {
		const url = `${endpoint}/${username}/${productSlug}/unique_code`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Update product tracking
	 *
	 * @param {Object} params Stock Update Params.
	 * @param {string[]} params.product_ids Product IDs
	 * @param {Object} params.tracking Tracking Object
	 * @param {requestCallback} [cb] The callback that handles the response.
	 * @param {errorCallback} [errorCb] The callback that handles the error.
	*/
	updateTracking(params, cb, errorCb) {
		const url = `${endpoint}/bulk_tracking`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	updateAutoTextBulk(params, cb, errorCb) {
		const url = `${endpoint}/bulk_follow_up_autotext`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	updateVisibilityBulk(params, cb, errorCb) {
		const url = `${endpoint}/bulk_is_public`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	updateResellerProductBulk(params, cb, errorCb) {
		const url = `${endpoint}/bulk_reseller_product`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	exportProducts(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/export?${query}`;
		client.get(url)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	bulkCreate(params, cb, errorCb) {
		const url = `${endpoint}/bulk_create`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// update is shared
	updateShared(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/shared`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// update is shared
	duplicateShared(id, cb, errorCb) {
		const url = `${endpoint}/${id}/shared/duplicate`;
		client.post(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Get Shared Product Details
	getSharedProductDetails(id, cb, errorCb) {
		const url = `${endpoint}/${id}/shared`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Product Codes by ID
	getCodes(params, cb, errorCb) {
		const url = `${endpoint}/codes`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Product by slug
	getProductBySlug(slug, cb, errorCb) {
		const url = `${endpoint}/${slug}/slug`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get Temporary Product Id
	getTempProductId(cb, errorCb) {
		const url = `${endpoint}/util/temp/product_id`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getHighDemandProduct(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/high_demand_product?${query}`;
		client.get(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	checkPrivate(params, cb, errorCb) {
		const url = `${endpoint}/check-private`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
};

export const getBlacklistedProducts = (cb, errorCb) => {
	const url = `${endpoint}/blacklisted`;
	client.get(url)
		.then((response) => {
			if (cb) cb(response.data);
		})
		.catch((e) => {
			if (errorCb) errorCb(e);
		});
};
